<template>
  <div class="content">
    <!-- 时间 -->
    <div class="time_wrap" :style="'top: ' + rowHeight + 'px'">
      <div class="time" :class="index % 2 == 0 ? 'stripe' : ''" :style="'height: ' + rowHeight + 'px'"
        v-for="(item, index) in timeList" :key="index">
        <div class="time_item">{{ item.timeStr }}</div>
      </div>
    </div>
    <!-- 背景猫 -->
    <div class="back_mao"></div>
    <!-- 场次 -->
    <div class="session_wrap" :style="'top: ' + rowHeight + 'px'">
      <div class="session"></div>
      <div class="session" v-for="(item, index) in themeList" :key="index">
        <div class="session_item" :style="'top:' + (session.top + 1) + 'px'" v-for="(session, i) in item.sessionList"
          :key="i">
          <item :session="session"></item>
        </div>
      </div>
    </div>
    <!-- 主题 -->
    <div class="theme" :style="'height: ' + rowHeight + 'px'">
      <div class="theme_item">
        <img class="theme_item_flower" src="../../assets/displayScreen/花.png">

      </div>
      <div class="theme_item">
        <div class="theme_item_wrap">
          <img class="theme_item_xin" src="../../assets/displayScreen/xin.png">
          <img class="theme_item_img" src="../../assets/displayScreen/银河特工队.png">
        </div>
      </div>
      <div class="theme_item">
        <div class="theme_item_wrap">
          <img class="theme_item_xin" src="../../assets/displayScreen/xin.png">
          <img class="theme_item_img" src="../../assets/displayScreen/小厨当家.png">
        </div>
      </div>
      <div class="theme_item">
        <div class="theme_item_wrap">
          <img class="theme_item_xin" src="../../assets/displayScreen/xin.png">
          <img class="theme_item_img" src="../../assets/displayScreen/森林守护者.png">
        </div>
      </div>
      <div class="theme_item">
        <div class="theme_item_wrap">
          <img class="theme_item_xin" src="../../assets/displayScreen/xin.png">
          <img class="theme_item_img" src="../../assets/displayScreen/魔法小侦探.png">
        </div>
      </div>
      <div class="theme_item">
        <div class="theme_item_wrap">
          <img class="theme_item_xin" src="../../assets/displayScreen/xin.png">
          <img class="theme_item_img" src="../../assets/displayScreen/盗梦空间.png">
        </div>
      </div>
      <div class="theme_item" style="width: 25%;">
        <div class="theme_item_wrap">
          <img class="theme_item_xin" src="../../assets/displayScreen/xin.png">
          <img class="theme_item_img" style="height: 38px;width: 100px;" src="../../assets/displayScreen/冒险岛.png">
        </div>
      </div>
    </div>
    <!-- 设备ID提示 -->
    <el-dialog :model-value="tipState" :width="400" :align-center="true">
      <div class="title">
        投屏设备ID: {{ uuid }}
      </div>
    </el-dialog>
    <div class="zhichi">技术支持:极迅科技</div>
  </div>
</template>

<script>
import item from './itemUrx.vue'

export default {
  name: "displayScreen",
  components: {
    item
  },
  data() {
    return {
      rowHeight: 30,          //时间轴高度
      timeList: [],           //时间集合
      themeList: [],          //主题集合
      uuid: '',
      tipState: false,
    }
  },
  methods: {

    /**
     * 查询
     */
    searchTimeChange() {
      let param = {
        sessionStartDateTime: this.$dayjs(this.timeList[0].time).format('YYYY-MM-DD HH:mm:ss'),
        sessionEndDateTime: this.$dayjs(this.timeList[this.timeList.length - 1].time).add(30, 'minute').format('YYYY-MM-DD HH:mm:ss'),
        orderType: 1,
        uuid: this.uuid,
      };
      // this.$POST("/customer/EomsApp/box/theme/show", param, false, "loading...", false ).then(res => {
      const query = Object.keys(param)
        .map(key => {
          const value = param[key] == null ? '' : param[key];
          return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        })
        .join('&');
      let url = "/customer/EomsApp/box/theme/show?" + query;
      this.$GET(url, false, "loading...", false).then(res => {

        //设置数据
        let dataList = res.data.deviceBoxes;
        this.tipState = false;
        //设置主题
        this.themeList = [];
        for (let i = 0; i < dataList.length; i++) {
          this.themeList.push({
            themeName: dataList[i].themeName,
          })
        }
        for (let i = 0; i < dataList.length; i++) {
          //取出场次
          let sessionList = [];
          for (let j = 0; j < dataList[i].themeSessionList.length; j++) {
            let today = this.$dayjs().format("YYYY-MM-DD");
            //判断是否跨天
            if (this.$dayjs(dataList[i].themeSessionList[j].startTime).isAfter(dataList[i].themeSessionList[j].endTime)) {
              today = this.$dayjs().add(1, "day").format("YYYY-MM-DD");
            }
            //判断是否在时间范围, 结束时间大于范围的开始
            let start = today + " " + dataList[i].themeSessionList[j].startTime;
            let end = today + " " + dataList[i].themeSessionList[j].endTime;
            let time = this.timeList[0].time;
            if (this.$dayjs(end).isAfter(time)) {
              //计算1分钟等于多少像素
              let mpx = this.$tools.accDiv(this.rowHeight, 30);
              //计算场次时长
              let len = this.$tools.accMul(this.$dayjs(end).diff(start, "minute"), mpx);
              //根据时间计算位置
              let top = 0;
              //开始时间早于屏幕时间
              if (this.$dayjs(time).isAfter(start)) {
                //像上偏移
                let diff = this.$dayjs(time).diff(start, "minute");
                top = this.$tools.accMul(diff, mpx) * -1;
              }
              //开始时间在屏幕时间里
              else {
                let diff = this.$dayjs(start).diff(time, "minute");
                top = this.$tools.accMul(diff, mpx);
              }
              //组建数据
              let session = {
                sessionDay: today,
                startTime: dataList[i].themeSessionList[j].startTime,
                endTime: dataList[i].themeSessionList[j].endTime,
                startTimeStr: this.$dayjs(start).format("HH:mm"),
                endTimeStr: this.$dayjs(end).format("HH:mm"),
                playerMax: dataList[i].playerCountMax ? dataList[i].playerCountMax : 8,
                top: top,
                len: len,
                gameState: 0,
                peopleNum: 0,
                tags: 0
              };
              //取出订单
              if (dataList[i].orderList) {
                for (let a = 0; a < dataList[i].orderList.length; a++) {
                  if (dataList[i].orderList[a].sessionStartTime == dataList[i].themeSessionList[j].startTime
                    && dataList[i].orderList[a].sessionEndTime == dataList[i].themeSessionList[j].endTime) {
                    session.gameState = dataList[i].orderList[a].gameState;
                    session.peopleNum = dataList[i].orderList[a].peopleNum;
                    session.tags = dataList[i].orderList[a].tags;
                    break;
                  }
                }
              }
              //如果场次开始时间大于现在时间,设置场次置灰
              if (this.$dayjs().isAfter(start) && session.peopleNum < session.playerMax && session.tags == 0
                && session.gameState == 0) {
                session.gameState = -1;
              }
              sessionList.push(session)
            }
          }

          //设置到主题里
          this.themeList[i].sessionList = sessionList;
        }


        //把冒险岛拆分2个
        let sessionListA = [];
        let sessionListB = [];
        for (let i = 0; i < this.themeList[5].sessionList.length; i++) {
          if (i % 2 == 0) {
            sessionListB.push(JSON.parse(JSON.stringify(this.themeList[5].sessionList[i])));
          } else {
            sessionListA.push(JSON.parse(JSON.stringify(this.themeList[5].sessionList[i])));
          }
        }
        //冒险岛B场加入集合
        let themeB = JSON.parse(JSON.stringify(this.themeList[5]));
        themeB.sessionList = sessionListB;
        this.themeList.push(themeB);
        //冒险岛A场替换集合
        let themeA = JSON.parse(JSON.stringify(this.themeList[5]));
        themeA.sessionList = sessionListA;
        this.themeList[5] = themeA;

      }).catch(e => {
        console.error("err:", e)
        this.themeList = [];
        if (!this.tipState) {
          this.tipState = true;
        }

      })

    },

    /**
     * 设置时间轴
     */
    setTime(e) {
      //算出半个小时的高度
      this.rowHeight = this.$tools.accDiv(e, 11).toFixed(0);
      //设置开始时间
      let time = this.$dayjs().startOf('hour');
      let timeStr = this.$dayjs().startOf('hour').format("HH:mm");
      //如果已超过半个小时
      if (this.$dayjs().minute() >= 30) {
        time = this.$dayjs().startOf('hour').add(30, 'minute');
        timeStr = this.$dayjs().startOf('hour').add(30, 'minute').format("HH:mm");
      }
      this.timeList = [{
        time: time,
        timeStr: timeStr,
      }];

      for (let i = 1; i < 10; i++) {
        if (i == 1) {
          this.timeList.push({
            time: this.$dayjs(this.timeList[0].time).add(30, 'minute'),
            timeStr: this.$dayjs(this.timeList[0].time).add(30, 'minute').format("HH:mm"),
          })
        } else {
          this.timeList.push({
            time: this.$dayjs(this.timeList[i - 1].time).add(30, 'minute'),
            timeStr: this.$dayjs(this.timeList[i - 1].time).add(30, 'minute').format("HH:mm"),
          })
        }

      }


      this.searchTimeChange();
    },
  },
  mounted() {

    let url = window.location.href;
    let arr = url.split("=");
    if (arr[1]) {
      this.uuid = arr[1];

      window.addEventListener('resize', e => {
        // 获取窗口的宽度和高度
        const width = window.innerWidth;
        const height = window.innerHeight;

        // 在控制台输出窗口的宽度和高度


        this.setTime(height);

      });

      this.setTime(window.innerHeight);

      clearInterval(this.timer);
      this.timer = setInterval(res => {
        this.setTime(window.innerHeight);
      }, 5 * 1000);
    }

  },
  beforeDestroy() {
    // 关闭定时器
    clearInterval(this.timer);
    this.timer = null
  },
}
</script>

<style scoped>
.zhichi
{
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: 160px;
  bottom: 10px;
  font-size: 14px;
  font-style: italic;
  margin-top: 4px;
  letter-spacing: 2px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.content
{
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  /*background: #0248fb;*/
  background: #113eaf;
  font-size: 30px;
  user-select: none;
}

.theme
{
  position: relative;
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #ffffff;
  z-index: 99;
  /*background: #0248fb;*/
  background: #0a40ca;
  ;
}

.theme_item
{
  position: relative;
  height: 100%;
  width: 12.5%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.theme_item_flower
{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 70px;
  width: 66px;
}

.theme_item_wrap
{
  position: absolute;
  bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.theme_item_xin
{
  position: relative;
  height: 24px;
  width: 27px;
  margin-bottom: 4px;
}

.theme_item_img
{
  position: relative;
  height: 38px;
  width: 152px;
}

.time_wrap
{
  position: absolute;
  top: 100px;
  width: 100%;
  color: #ffffff;
}

.time
{
  position: relative;
  height: 100px;
  width: 100%;
  border-top: 1px solid #000000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.time_item
{
  position: relative;
  margin-left: 4.2%;
}

.stripe
{
  /*background: #0542de;*/
  background: #1c51d8;
  ;
  border: none;
}

.session_wrap
{
  position: absolute;
  top: 90px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 2px solid #000000;
  color: #333333;
}

.session
{
  position: relative;
  height: 100%;
  width: 12.5%;
  /*background: rgba(242, 242, 242, 0.2);*/
}

.session_item
{
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 20px;
  width: 80%;
}

.back_mao
{
  position: fixed;
  right: 30px;
  bottom: 30px;
  background: url('../../assets/displayScreen/mao.png');
  height: 242px;
  width: 122px;
  border-radius: 8px;
  background-size: cover;
}


.title
{
  font-size: 24px;
  height: 100px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-dialog)
{
  border-radius: 8px;
}

:deep(.el-dialog__body)
{
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
